<script setup>
import { computed } from 'vue'

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

const headingClass = computed(() => {
    return {
        h1: 'leading-[3rem] text-4xl font-bold text-zinc-100',
        h2: 'leading-[2.5rem] text-3xl font-bold text-zinc-200',
        h3: 'leading-[2.25rem] text-2xl font-bold text-zinc-200',
        h4: 'leading-[2rem] text-xl font-bold text-zinc-300',
        h5: 'leading-[1.75rem] text-lg font-bold text-zinc-400',
        h6: 'leading-[1.5rem] text-base font-bold text-zinc-400',
    }[props.content['level']]
})

const heading = computed(() => {
    return {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
    }[props.content['level']]
})
</script>

<template>
    <component
        :is="heading"
        :class="headingClass"
    >
        {{ props.content['content'] }}
    </component>

    <div class="leading-10"></div>
</template>
